import customFetchBase from "../../../principal/customFetchBase";
import {createApi} from "@reduxjs/toolkit/query/react";

export const asignaturasApi = createApi({
    reducerPath: "asignaturasApi",
    baseQuery: customFetchBase,
    tagTypes: ["Asignaturas"],
    endpoints: () => ({}),
});
